import React from 'react'
import { Choose1, Choose2 } from '../Reusable/Choose'

const Choose = () => {
    return (
        <div className='bg-[#06000A] relative z-[500] flex flex-col gap-5 lg:px-[8%] px-[4%] lg:pt-[6%] py-[9%]'>
            <div data-aos="fade-down" className='flex w-full items-center justify-center z-[500]'>
                <div className='lg:w-[50%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='lg:text-[55px] text-[30px] text-white font-semibold '>Why Choose <span className='text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-700'>
                        Us
                    </span></p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Join the agricultural revolution with Blockfarms — leveraging blockchain to enhance farm-to-table traceability, ensure fair pricing, and promote sustainable farming practices globally.</p>
                </div>
            </div>
            {/* <p className='text-[100px] z-[100] lg:block hidden top-6 left-[25%] absolute text-white font-bold text-opacity-10'>Whe Blockfarms</p> */}
            <div data-aos="zoom-in-down" className='w-full grid lg:grid-cols-3 gap-11 md:grid-cols-2 grid-cols-1'>
                <Choose1
                    img={"/Blockfarm/advance.svg"}
                    heading={"Hardware Procurement"}
                    paragraph={"Our team of experts will assist you in purchasing the hardware of your choosing, as well as handling the shipping process at the most competitive prices."}
                />
                <Choose2
                    img={"/Blockfarm/smart.svg"}
                    heading={"Industry Leading Hosting Facilities"}
                    paragraph={"We host our customers’ miners in one of the world’s top mining facilities, with extremely competitive power rates."}
                />
                <Choose1
                    img={"/Blockfarm/set.svg"}
                    heading={"Maintenance"}
                    paragraph={"We have an onsite repair center within all our facilities, where our team of engineers are available to tend to all repairs and maintenance in a swift manner to efficiently reduce downtime."}
                />
            </div>

        </div>
    )
}

export default Choose